const { fetchJson } = require('./index');
const { doFlash } = require('./flash');
const { serializeForQueryString } = require('../lib/urlHelper');

const AUTHENTICATING_STUDENT = 'AUTHENTICATING_STUDENT';
const AUTHENTICATED_STUDENT = 'AUTHENTICATED_STUDENT';

const LOGGING_STUDENT_OUT = 'LOGGING_STUDENT_OUT';
const LOGGED_STUDENT_OUT = 'LOGGED_STUDENT_OUT';

const FETCHING_LOGGED_IN_STUDENT = 'FETCHING_LOGGED_IN_STUDENT';
const FETCHED_LOGGED_IN_STUDENT = 'FETCHED_LOGGED_IN_STUDENT';

const FAILED_CREATE_MESSAGE = 'Failed to create a new student';
const SUCCEEDED_CREATE_MESSAGE = 'Student created';
const CREATED_STUDENT = 'CREATED_STUDENT';
const CREATING_STUDENT = 'CREATING_STUDENT';

const FAILED_DELETE_MESSAGE = 'Deletion failed';
const SUCCEEDED_DELETE_MESSAGE = 'Student deleted';
const DELETED_STUDENT = 'DELETED_STUDENT';
const DELETING_STUDENT = 'DELETING_STUDENT';

const FAILED_FETCH_SINGLE_MESSAGE =
	'Failed to retrieve the student data from the server';
const FETCHED_STUDENT = 'FETCHED_STUDENT';
const FETCHING_STUDENT = 'FETCHING_STUDENT';

const FAILED_FETCH_MESSAGE =
	'Failed to retrieve the list of students from the server';
const FETCHED_STUDENTS = 'FETCHED_STUDENTS';
const FETCHING_STUDENTS = 'FETCHING_STUDENTS';

const IMPORTING_STUDENTS = 'IMPORTING_STUDENTS';
const IMPORTED_STUDENTS = 'IMPORTED_STUDENTS';

const FAILED_REMOVING_STUDENT =
	'Could not remove that student from the classroom';
const SUCCEEDED_REMOVAL_MESSAGE = 'Removed student from classroom';
const REMOVED_STUDENT_FROM_CLASSROOM = 'REMOVED_STUDENT_FROM_CLASSROOM';
const REMOVING_STUDENT_FROM_CLASSROOM = 'REMOVING_STUDENT_FROM_CLASSROOM';

const SELECT_STUDENT = 'SELECT_STUDENT';

const FAILED_UPDATE_MESSAGE = 'Update failed';
const SUCCEEDED_UPDATE_MESSAGE = 'Student updated';
const UPDATED_STUDENT = 'UPDATED_STUDENT';
const UPDATING_STUDENT = 'UPDATING_STUDENT';

const fail = (type, message) => ({
	type,
	error: true,
	payload: {
		error: message
	}
});

const success = (type, list) => ({
	type,
	payload: { list }
});

const doAction = function(
	method,
	body,
	doingActionType,
	didActionType,
	failureMessage,
	extra = {}
) {
	return function(dispatch, getState) {
		dispatch({ type: doingActionType });
		// We wrap with an extra promise, so that if there is a failure, no subsequent "then"'s will run after our catch block.
		return new Promise(function(resolve, reject) {
			return fetchJson(extra.url ? extra.url : '/api/students', {
				method,
				body
			}).then(
				function(responseJson) {
					if (responseJson.status === 'success') {
						if (extra.successMessage) {
							dispatch(doFlash('success', 'Success!', extra.successMessage));
						}
						if (extra.getSuccessPayload) {
							dispatch({
								type: didActionType,
								payload: extra.getSuccessPayload(responseJson)
							});
						} else {
							dispatch(success(didActionType, responseJson.data.list));
						}
					} else {
						dispatch(doFlash('error', 'Error!', responseJson.message));
						dispatch(fail(didActionType, responseJson.message));
					}
					return resolve();
				},
				function(error) {
					dispatch(doFlash('error', 'Error!', failureMessage));
					dispatch(fail(didActionType, error.response['statusText']));
					return reject(error);
				}
			);
		});
	};
};

const doActionWithServerValidations = function(
	method,
	body,
	doingActionType,
	didActionType,
	failureMessage,
	extra = {}
) {
	// Create and update validate the student on the backend, so this function returns validation errors
	// as part of the rejected promise if the API call fails.  The returned error is formatted to be usable
	// by redux-form to properly display errors.
	// This also doesn't show flash messages when the request fails, since redux-form handles notification that
	// there were errors.
	return function(dispatch, getState) {
		dispatch({ type: doingActionType });
		// We wrap with an extra promise, so that if there is a failure, no subsequent "then"'s will run after our catch block.
		return new Promise(function(resolve, reject) {
			return fetchJson(extra.url ? extra.url : '/api/students', {
				method,
				body
			}).then(
				function(responseJson) {
					if (responseJson.status === 'success') {
						if (extra.successMessage) {
							dispatch(doFlash('success', 'Success!', extra.successMessage));
						}
						if (extra.getSuccessPayload) {
							dispatch({
								type: didActionType,
								payload: extra.getSuccessPayload(responseJson)
							});
						} else {
							dispatch(success(didActionType, responseJson.data.list));
						}
					} else {
						dispatch(doFlash('error', 'Error!', responseJson.message));
						dispatch(fail(didActionType, responseJson.message));
					}
					return resolve(responseJson.data);
				},
				function(error) {
					dispatch(fail(didActionType, error.response['statusText']));
					return reject(error.response.json());
				}
			);
		});
	};
};

const failFetchingStudents = error => ({
	type: FETCHED_STUDENTS,
	error: true,
	payload: {
		error
	}
});

const fetchedStudents = (students, pages) => ({
	type: FETCHED_STUDENTS,
	payload: {
		students,
		pages
	}
});

const fetchingStudents = () => ({ type: FETCHING_STUDENTS });

module.exports = {
	AUTHENTICATED_STUDENT,
	AUTHENTICATING_STUDENT,

	LOGGING_STUDENT_OUT,
	LOGGED_STUDENT_OUT,

	FETCHING_LOGGED_IN_STUDENT,
	FETCHED_LOGGED_IN_STUDENT,

	FAILED_CREATE_MESSAGE,
	CREATED_STUDENT,
	CREATING_STUDENT,

	FAILED_DELETE_MESSAGE,
	DELETED_STUDENT,
	DELETING_STUDENT,

	FAILED_FETCH_MESSAGE,
	FETCHED_STUDENT,
	FETCHING_STUDENT,
	FETCHED_STUDENTS,
	FETCHING_STUDENTS,

	REMOVED_STUDENT_FROM_CLASSROOM,
	REMOVING_STUDENT_FROM_CLASSROOM,

	SELECT_STUDENT,

	FAILED_UPDATE_MESSAGE,
	UPDATED_STUDENT,
	UPDATING_STUDENT,

	logStudentIn(username, password, schoolId) {
		const method = 'post';
		const payload = { username, password, school_id: schoolId };
		const doingActionType = AUTHENTICATING_STUDENT;
		const didActionType = AUTHENTICATED_STUDENT;
		const failureMessage = null;

		return doActionWithServerValidations(
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage,
			{
				url: '/student_auth/login',
				getSuccessPayload(responseJson) {
					return { student: responseJson.data };
				}
			}
		);
	},

	logStudentOut() {
		const method = 'get';
		const payload = null;
		const doingActionType = LOGGING_STUDENT_OUT;
		const didActionType = LOGGED_STUDENT_OUT;
		const failureMessage = null;

		return doActionWithServerValidations(
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage,
			{
				url: '/student_auth/logout',
				getSuccessPayload(responseJson) {
					return null;
				}
			}
		);
	},

	fetchLoggedInStudent() {
		const method = 'get';
		const payload = null;
		const doingActionType = FETCHING_LOGGED_IN_STUDENT;
		const didActionType = FETCHED_LOGGED_IN_STUDENT;
		const failureMessage = null;

		return doAction(
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage,
			{
				url: '/student_auth/show',
				getSuccessPayload(responseJson) {
					return { student: responseJson.data };
				}
			}
		);
	},

	createStudent(student) {
		const method = 'post';
		const payload = student;
		const doingActionType = CREATING_STUDENT;
		const didActionType = CREATED_STUDENT;
		const failureMessage = null;

		return doActionWithServerValidations(
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage,
			{
				successMessage: SUCCEEDED_CREATE_MESSAGE,
				getSuccessPayload(responseJson) {
					return { student: responseJson.data };
				}
			}
		);
	},

	deleteStudent(studentId) {
		const method = 'delete';
		const payload = null;
		const doingActionType = DELETING_STUDENT;
		const didActionType = DELETED_STUDENT;
		const failureMessage = FAILED_DELETE_MESSAGE;

		return doAction(
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage,
			{
				successMessage: SUCCEEDED_DELETE_MESSAGE,
				url: `/api/students/${ studentId }`,
				getSuccessPayload() {
					return {};
				}
			}
		);
	},

	fetchStudent(studentId) {
		const method = 'get';
		const payload = null;
		const doingActionType = FETCHING_STUDENT;
		const didActionType = FETCHED_STUDENT;
		const failureMessage = FAILED_FETCH_SINGLE_MESSAGE;

		return doAction(
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage,
			{
				getSuccessPayload(responseJson) {
					return { student: responseJson.data.student };
				},
				url: `/api/students/${ studentId }`
			}
		);
	},

	fetchStudents(criteria) {
		const method = 'get';
		const body = null;
		const doingActionType = FETCHING_STUDENTS;
		const didActionType = FETCHED_STUDENTS;
		const failureMessage = FAILED_FETCH_MESSAGE;

		return doAction(
			method,
			body,
			doingActionType,
			didActionType,
			failureMessage,
			{
				getSuccessPayload(responseJson) {
					return {
						list: responseJson.data.list,
						pages: responseJson.data.pages
					};
				},
				url: `/api/students?${ serializeForQueryString(criteria) }`
			}
		);
	},

	fetchUpdatedStudents(criteria) {
		const method = 'get';
		const body = null;
		const doingActionType = FETCHING_STUDENTS;
		const didActionType = FETCHED_STUDENTS;
		const failureMessage = FAILED_FETCH_MESSAGE;

		return doAction(
			method,
			body,
			doingActionType,
			didActionType,
			failureMessage,
			{
				getSuccessPayload(responseJson) {
					return {
						list: responseJson.data.list,
						pages: responseJson.data.pages
					};
				},
				url: `/api/students/updated?${ serializeForQueryString(criteria) }`
			}
		);
	},

	fetchStudentsBySchool(schoolId) {
		// Fetches all students for a school without pagination
		// This is really just a convenience method for `fetchStudents` above
		const method = 'get';
		const payload = null;
		const doingActionType = FETCHING_STUDENTS;
		const didActionType = FETCHED_STUDENTS;
		const failureMessage = FAILED_FETCH_MESSAGE;

		return doAction(
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage,
			{ url: `/api/students?school_id=${ schoolId }` }
		);
	},

	fetchStudentsByClassroom(classroomId) {
		// Fetches all students for a classroom without pagination
		// This is really just a convenience method for `fetchStudents` above
		const method = 'get';
		const payload = null;
		const doingActionType = FETCHING_STUDENTS;
		const didActionType = FETCHED_STUDENTS;
		const failureMessage = FAILED_FETCH_MESSAGE;

		return doAction(
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage,
			{ url: `/api/students?classroom_id=${ classroomId }` }
		);
	},

	importBySchool(data) {
		const method = 'post';
		const payload = data;
		const doingActionType = IMPORTING_STUDENTS;
		const didActionType = IMPORTED_STUDENTS;
		const failureMessage = 'Failed to import students';

		return doAction(
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage,
			{
				successMessage: 'Successfully imported students',
				getSuccessPayload(responseJson) {
					return null;
				},
				url: '/api/students/by_school'
			}
		);
	},

	removeStudentFromClassroom(studentId, classroomId) {
		const method = 'post';
		const payload = { student_id: studentId, classroom_id: classroomId };
		const doingActionType = REMOVING_STUDENT_FROM_CLASSROOM;
		const didActionType = REMOVED_STUDENT_FROM_CLASSROOM;
		const failureMessage = FAILED_REMOVING_STUDENT;

		return doAction(
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage,
			{
				successMessage: SUCCEEDED_REMOVAL_MESSAGE,
				url: '/api/students/remove_from_classroom'
			}
		);
	},

	selectStudent(student) {
		return {
			type: SELECT_STUDENT,
			payload: {
				student
			}
		};
	},

	updateStudent(student) {
		const method = 'PATCH';
		const payload = student;
		const doingActionType = UPDATING_STUDENT;
		const didActionType = UPDATED_STUDENT;
		const failureMessage = null;

		return doActionWithServerValidations(
			method,
			payload,
			doingActionType,
			didActionType,
			failureMessage,
			{
				successMessage: SUCCEEDED_UPDATE_MESSAGE,
				getSuccessPayload(responseJson) {
					return { student: responseJson.data };
				},
				url: `/api/students/${ student.id }`
			}
		);
	}
};



// WEBPACK FOOTER //
// ./frontend/a2i/js/actions/students.js